import { createFeatureSelector } from '@ngrx/store';

export const svcDropdownsFeatureSelector = createFeatureSelector<any>('svcDropdowns');
